import type {Theme} from '@material-ui/core/styles'
import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import {GoTheme} from '@yandex-taxi/go-web-components'

import {createTheme} from '../../theme/createTheme'

const colorSecondary = '#21201F'
const colorPrimary = '#FFDE40'
const fontSize = 16
const lineHeight = '20px'
const fontFamily = '"YS Text", Helvetica, Arial, sans-serif'

type ThemeWithGo = Theme & {go: GoTheme}

const createMuiThemeWithGo = (): ThemeWithGo => {
  const {go} = createTheme()
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: colorPrimary,
      },
      secondary: {
        main: colorSecondary,
      },
      grey: {
        100: '#E7E5E1',
        200: '#E7E7E5',
        300: '#F2F1EE',
      },
      text: {
        primary: colorSecondary,
      },
      common: {
        black: colorSecondary,
      },
      error: {
        main: '#FB482D',
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 320,
        md: 768,
        lg: 1280,
        xl: 1920,
      },
    },
    spacing: 10,
    typography: {
      fontFamily,
      fontSize,
      button: {
        fontFamily,
        lineHeight,
        textTransform: 'none',
      },
      body1: {
        fontSize,
        lineHeight,
      },
      h6: {
        fontFamily,
        fontSize: 24,
        lineHeight: '30px',
      },
    },
    shape: {
      borderRadius: 16,
    },
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
    },
  })

  return {
    ...theme,
    go: {
      ...go,
      mixins: {
        ...go.mixins,
        // типографика из Go ломает текущую тему в LPC
        // TODO переехать на одну тему
        typography: theme.typography as any,
      },
    },
  }
}

export const theme = createMuiThemeWithGo()
